import { makeStyles } from '@material-ui/core';
import LogoDark from '../../assets/univerus_logo_dark.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 60,
    transition: 'height 200ms ease',
  },
});

/**
 * LogoFull - Univerus Hub full logo component
 * Always displays the dark logo variant for consistency
 */
const LogoFull = () => {
  const classes = useStyles();

  return <img src={LogoDark} alt="Univerus Central" className={classes.img} />;
};

export default LogoFull;
